module.exports = __webpack_public_path__ + "static/media/ski.e8b63a4e.png";